module.exports = __webpack_public_path__ + "static/FNOL-acff4ef489086f91857783a071becd9e.svg";